module.exports = __webpack_public_path__ + "static/img/bg-news.25e17dbd.png";